import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@wellesley/ui'
import { FC } from 'react'

type PollTypeSelectProps = {
  value: boolean
  onChange: (isMultiple: boolean) => void
}

const PollTypeSelect: FC<PollTypeSelectProps> = ({ value, onChange }) => {
  return (
    <div className="[&>div]:!w-[auto]">
      <Select
        value={value ? 'multiple' : 'single'}
        onValueChange={(value) => onChange(value === 'multiple')}
      >
        <SelectTrigger className="!p-none !h-auto !border-none text-base text-gray-500">
          <SelectValue className="bg-blue-200" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="single">Single choice</SelectItem>
          <SelectItem value="multiple">Multiple choice</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}

export default PollTypeSelect
